import { vars } from '@repo/config';
import { postRawRequest } from '../../httpClient';

export async function ingestSubtitlesApi(): Promise<Response> {
  return postRawRequest({
    path: '/sys/subtitles/ingest',
    body: { vaultUrl: vars.url.vaultUrl },
  });
}
